import { connect } from 'react-redux';

import StatusBanner from '../components/StatusBanner';

import {
  redirectSecureEdge,
  generateMigrateLink,
  checkMigrationState,
} from '../actions/account';

const mapStateToProps = (state, ownProps) => ({
  accountId: state.account.selected,
  hasSecureEdgeFeature: state.account.features.includes('secure_edge') || false,
  readOnlyDate: state.account.readOnlyDate || '',
  readOnlyState: state.account.readOnlyState || false,
  migrateRedirect: state.account.migrateLink || {},
  // migrateRedirect: state.account.migrateLink || '',
  migrateStatus: state.account.migrated_status,
  migrateLink: state.account.migrateLink || '',
  migrateAction: state.account.action,
  isMigrated: state.account.migrate_to_secure_edge || false,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  checkAccountStatus: () => {
    dispatch(checkMigrationState());
  },
  redirectSecureEdge: () => {
    dispatch(redirectSecureEdge());
  },
  generateMigrateLink: params => {
    dispatch(generateMigrateLink(params));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatusBanner);
